import queryString from 'query-string';

export type AppLanguage = 'en' | 'zh-Hans' | 'zh-Hant' | 'ko';
export type ChatLanguage = 'en' | 'zh' | 'ko';

const chatLanguages: Record<AppLanguage, ChatLanguage> = {
  en: 'en',
  'zh-Hans': 'zh',
  'zh-Hant': 'en',
  ko: 'ko',
};

// Contract shared with ikasa_platform VisitorSupportStep (screen names).
const steps = [
  'visitor_help', 'visitor_return_area', 'visitor_confirm_can_share',
  'visitor_share_process', 'visitor_shared_waiting', 'visitor_share_qr', 'visitor_service_suspension',
];

export function parseSupportContext(search: string) {
  const query = queryString.parse(search);
  const memberId = typeof query.ikasa_id === 'string' && query.ikasa_id.trim()
    ? query.ikasa_id : undefined;
  const appLanguage = typeof query.app_lang === 'string' &&
    Object.prototype.hasOwnProperty.call(chatLanguages, query.app_lang)
    ? query.app_lang as AppLanguage : undefined;
  // Only a valid scalar app_lang identifies Visitor. Old Japanese links stay Japanese.
  // Missing/invalid/contradictory lang is repaired from the original selection.
  const expected = appLanguage ? chatLanguages[appLanguage] : 'ja';
  const language = query.lang === expected ? query.lang : expected;
  const step = typeof query.step === 'string' && steps.includes(query.step)
    ? query.step : null;
  const profile = appLanguage ? {
    visitor_mode: true,
    app_lang: appLanguage,
    current_step: step,
  } : undefined;
  return { memberId, appLanguage, language, profile };
}

// Remove only the fields owned by this integration, never reset the whole profile.
export const clearedVisitorProfile = {
  visitor_mode: false,
  app_lang: null,
  current_step: null,
};

export function hasVisitorProfile(profile?: { [key: string]: unknown }) {
  return !!profile && ['visitor_mode', 'app_lang', 'current_step'].some(
    key => Object.prototype.hasOwnProperty.call(profile, key)
  );
}
